import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('nonprofitsImport') || initialState;

export const selectSubmitting = createSelector(selectState, (state) => state.get('submitting'));
